import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  EmbeddedSignupExchangePayload,
  EmbeddedSignupExchangeResponse,
  EmbeddedSignupSession,
  MetaOnboardingConfig,
  SetupPayload,
  WhatsAppAccount,
} from '../models/api.models';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class SetupService {
  constructor(private readonly api: ApiService) {}

  metaConfig(): Observable<MetaOnboardingConfig> {
    return this.api.get<MetaOnboardingConfig>('/whatsapp/meta-config');
  }

  createEmbeddedSignupSession(): Observable<EmbeddedSignupSession> {
    return this.api.get<EmbeddedSignupSession>('/whatsapp/embedded-signup/session');
  }

  exchangeEmbeddedSignup(payload: {
    code: string;
    state: string;
    waba_id?: string;
    phone_number_id?: string;
    phone_number?: string;
  }): Observable<EmbeddedSignupExchangeResponse> {
    return this.api.post<EmbeddedSignupExchangeResponse>(
      '/whatsapp/embedded-signup/exchange',
      payload as EmbeddedSignupExchangePayload
    );
  }

  completeOnboarding(payload: SetupPayload): Observable<WhatsAppAccount> {
    return this.api.post<WhatsAppAccount>('/whatsapp/onboarding', payload);
  }

  connectFacebook(payload: Record<string, string>): Observable<{ redirect_url: string; business_manager_id: string }> {
    return this.api.post<{ redirect_url: string; business_manager_id: string }>('/whatsapp/connect-facebook', payload);
  }
}
